/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Timotius Albert",
  title: "Hi all, I'm Albert",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with Reactjs / React Native / Ionic / Flask / Django / DotNet and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1pjJNGdfqb5Qx_nz5f7irpsrzXyMXLZkY/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/darkevo24",
  linkedin: "https://www.linkedin.com/in/timotius-albert-518b3a1aa/",
  gmail: "timotiusalbert46@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as AWS / Azure"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "flask & django",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: ".NET",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "IIS",
      fontAwesomeClassname: "fab fa-windows"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Developer",
      company: "Cloudster Connect PTY LTD",
      companylogo: require("./assets/images/cloudster.jpg"),
      date: "July 2023 – Oct 2023",
      descBullets: [
        "Collaborated closely with a team of developers and project managers to build a robust website that integrates with CargoWise, enabling smooth data synchronization and real-time tracking of shipments and orders.",
        "Developed custom APIs and utilized RESTful services to establish secure and efficient communication between the website and CargoWise platform.",
        "Implemented user-friendly interfaces, ensuring a seamless user experience and intuitive navigation for customers interacting with the website."
      ],
      // desc: "Flask, Python, SqLite3, API, Hosting"
    },
    {
      role: "FullStack Developer",
      company: "Buyeroad",
      companylogo: require("./assets/images/buyeroad-icon.jpeg"),
      date: "August 2022 – July 2023",
      descBullets: [
        "Created an E-Commerce website using the Flask framework.",
        "Developed the front-end website architecture.",
        "Designed user interactions on web pages.",
        "Designed user interactions on web pages.",
        "Created servers and databases for functionality."
      ],
      desc: "Flask, Python, SqLite3, API, Hosting"
    },
    {
      role: "Developer",
      company: "TokenMinds",
      companylogo: require("./assets/images/tokenminds.jpeg"),
      date: "May 2021 – August 2022",
      desc: "React JS, Next JS, JavaScript, TypeScript, Vercel, Redux, Blockchain",
      descBullets: [
        "Front end development for blockchain applications and related web sites and web apps.",
        "Maintaining client and server-side applications, through AWS",
        "Implementing front end development processes and complying with best practices in data protection",
        "Keeping up with current front end technologies and hosting methods"
      ]
    },
    {
      role: "Developer",
      company: "Singapore Freelancer",
      companylogo: require("./assets/images/self-employee.jpeg"),
      date: "March 2020 – April 2021",
      desc: "React, Django, Flask, API, AWS, Redux, Python, SqLite3, JavaScript, TypeScript",
      descBullets: [
        "Create a Fullstack Web Application for Singapore Client",
        "Participating in the design and creation of scalable software",
        "Writing clean, functional code on the front- and back-end",
        "Testing and fixing bugs or other coding issues"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/data-id.png"),
      projectName: "Data Indonesia",
      projectDesc: "Maintanance Data for Indonesia Government Using React, Python and Java Spring",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://data.go.id/home"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/NHB30_Gold.png"),
      projectName: "NHB",
      projectDesc: "Maintanance Singapore Government Project Using Dotnet SiteCore",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.nhb.gov.sg/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ntainers-logo.png"),
      projectName: "Ntainers",
      projectDesc: "Maintanance Australia StartUp Project Using Dotnet",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ntainers.co/"
        }
      ]
    },
    {
      image: require("./assets/images/buyeroad-icon.jpeg"),
      projectName: "Buyeroad",
      projectDesc: "E-commerce projects in Europe Countries Using Python Flask Framework",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.buyeroad.co.uk/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/youanswer-icon.png"),
      projectName: "YouAnswer",
      projectDesc: "Search Engine Project Using Python Flask Framework",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.youanswer.eu/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Python Hackerrank",
      subtitle:
        "This certificate recognizes my mastery of various Python concepts, including data structures, algorithms, object-oriented programming, and more. Through my participation in numerous coding challenges and contests, i have consistently showcased my expertise and determination, achieving outstanding results and solving complex problems with creativity and precision.",
      image: require("./assets/images/python-hackerrank.PNG"),
      imageAlt: "Python",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/1a8ae878cf0a"
        },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "SQL Hackerrank",
      subtitle:
        "This certificate recognizes my mastery of various SQL concepts, including querying, data manipulation, database design, and more. Through my participation in numerous coding challenges and contests, I have consistently showcased my expertise and problem-solving skills, achieving outstanding results and efficiently retrieving and manipulating data from complex database structures.",
      image: require("./assets/images/sql-hackerrank.PNG"),
      imageAlt: "SQL",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/2ea0c1ac6343"
        }
      ]
    },

    {
      title: "BWA FullStack Developer",
      subtitle: "Completed Certifcation from BWA FullStack Development",
      image: require("./assets/images/BuildWithAngga.png"),
      imageAlt: "BWA Logo",
      footerLink: [
        { name: "Certification", url: "https://drive.google.com/file/d/1BnolOaSKIbPCvWXUWWY9U0Pu7v_Lfg_1/view" }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Testimony",
  subtitle: emoji(
    "Here is the testimony of my past collagues 😄"
  ),

  talks: [
    {
      title: "Hemang Joshi",
      subtitle: "Developer in TokenMinds , Singapore",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Open for full time / part time / freelance",
  number: "+6285775236846",
  email_address: "timotiusalbert46@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
